import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { MdAdd, MdSettings } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import { AccountAvatar } from "../../components/AccountAvatar";
import { Loader } from "../../components/Loader";
import { Title } from "../../components/Title";
import {
  ArticlesDocument,
  useArticlesQuery,
  useDeleteArticleMutation,
} from "../../graphql";
import { formatDateTime } from "../../utils";

const ArticlesPage: React.FC = () => {
  const toast = useToast();
  const history = useHistory();

  const [remove] = useDeleteArticleMutation();
  const { data, loading, refetch } = useArticlesQuery();

  const onDelete = async (id: number) => {
    await remove({
      variables: {
        id: id,
      },
      refetchQueries: [{ query: ArticlesDocument }],
    });

    toast({
      description: "Artikulli u fshi.",
      status: "success",
      isClosable: true,
    });
  };

  const goToEdit = (id) => {
    history.push(`/article/${id}`);
  };

  const goToCreate = () => {
    history.push(`/articles/create`);
  };

  return (
    <>
      <Box
        borderWidth="1px"
        borderRadius="lg"
        overflow="hidden"
        p={2}
        background="white"
      >
        <Title title="Lista e artikujve">
          <Button
            leftIcon={<MdAdd />}
            colorScheme="blue"
            size="sm"
            variant="ghost"
            onClick={goToCreate}
          >
            Shto
          </Button>
        </Title>

        {loading ? (
          <Loader />
        ) : (
          <Table variant="striped" size="sm">
            <Thead>
              <Tr>
                <Th>Titulli</Th>
                <Th>Gjuha</Th>
                <Th>Autori</Th>
                <Th isNumeric>Data</Th>
              </Tr>
            </Thead>
            <Tbody>
              {data.articles.nodes.map((item) => (
                <Tr key={item.id}>
                  <Td>{item.title}</Td>
                  <Td>{item.language.name}</Td>
                  <Td>
                    <Link to={`/item/${item.id}`}>
                      <AccountAvatar
                        account={item.author}
                        role={false}
                        size="xs"
                      />
                    </Link>
                  </Td>
                  <Td isNumeric>{formatDateTime(item.createdAt)}</Td>
                  <Td isNumeric>
                    <Menu>
                      <MenuButton
                        px={2}
                        py={0.5}
                        transition="all 0.2s"
                        _focus={{ boxShadow: "outline" }}
                      >
                        <MdSettings />
                      </MenuButton>
                      <MenuList>
                        <MenuItem
                          onClick={() => {
                            goToEdit(item.id);
                          }}
                        >
                          Redakto
                        </MenuItem>
                        <MenuItem onClick={() => onDelete(item.id)}>
                          Fshi
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        )}
      </Box>
    </>
  );
};

export default ArticlesPage;
